import { EventType, ElementType, EventAction } from '@cof/stratum';

// PRODUCT_NAME is a required export of this file (use your DevNav component name)
const PRODUCT_NAME = 'fs-personal-mfe-staticassets';
// PRODUCT_VERSION is a required export of this file
const PRODUCT_VERSION = '2.0.4';
var TagKey;
(function (TagKey) {
    /**
     * Enumerate keys of tag catalog entries here for easy
     * use and consistent reference across your application.
     *
     * The values of the tag keys can be any string or number
     * value. These keys will not be referenced outside
     * of the application.
     */
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_MODPREQUAL"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_MODPREQUAL";
    TagKey["VIEW_PERSONAL_CONTACT"] = "VIEW_PERSONAL_CONTACT";
    TagKey["PERSONAL_NAME_VIEW_ELIGIBILITY_MODAL"] = "PERSONAL_NAME_VIEW_ELIGIBILITY_MODAL";
    TagKey["PQ_TEXT_INPUT_FIELD_VIEW_FULL_ELIGIBILITY_REDIRECT"] = "PQ_TEXT_INPUT_FIELD_VIEW_FULL_ELIGIBILITY_REDIRECT";
    TagKey["PQ_TEXT_INPUT_FIELD_PREFILLED_FIELD"] = "PQ_TEXT_INPUT_FIELD_PREFILLED_FIELD";
    TagKey["PQ_TEXT_INPUT_FIELD_EDITED_FIELD"] = "PQ_TEXT_INPUT_FIELD_EDITED_FIELD";
    TagKey["PERSONAL_NAME_CO_APPLICANT_ADDED"] = "PERSONAL_NAME_CO_APPLICANT_ADDED";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_NAME"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_NAME";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_COMMUNICATION"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_COMMUNICATION";
    TagKey["PREQUALIFY_NEXT_PAGE_CTA"] = "PREQUALIFY_NEXT_PAGE_CTA";
    TagKey["PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE"] = "PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE";
    TagKey["PERSONAL_COMMUNICATION_PHONE_NUMBER_TYPE"] = "PERSONAL_COMMUNICATION_PHONE_NUMBER_TYPE";
    TagKey["MOBILE_NUMBER_MODULE_CONFIRM_MOBILE_NUMBER_MODAL"] = "MOBILE_NUMBER_MODULE_CONFIRM_MOBILE_NUMBER_MODAL";
    TagKey["MOBILE_NUMBER_MODULE_SMS_OPT_PHONE_CHANGE_MODAL"] = "MOBILE_NUMBER_MODULE_SMS_OPT_PHONE_CHANGE_MODAL";
    TagKey["PERSONAL_COMMUNICATION_SMS_OPT_SELECTION"] = "PERSONAL_COMMUNICATION_SMS_OPT_SELECTION";
    TagKey["MOBILE_NUMBER_MODULE_PHONE_MODAL_SAVE"] = "MOBILE_NUMBER_MODULE_PHONE_MODAL_SAVE";
    TagKey["MOBILE_NUMBER_MODULE_PHONE_MODAL_DISMISS"] = "MOBILE_NUMBER_MODULE_PHONE_MODAL_DISMISS";
    TagKey["PERSONAL_COMMUNICATION_SMS_OPT_ON_PAGE"] = "PERSONAL_COMMUNICATION_SMS_OPT_ON_PAGE";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_IDENTITY"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_IDENTITY";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_ADDRESS"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_ADDRESS";
    TagKey["PERSONAL_EMPLOYMENT_ABOUT_EMPLOYMENT_STATUS_MODAL"] = "PERSONAL_EMPLOYMENT_ABOUT_EMPLOYMENT_STATUS_MODAL";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_EMPLOYMENT"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_EMPLOYMENT";
    TagKey["PERSONAL_EMPLOYMENT_EMPLOYMENT_STATUS"] = "PERSONAL_EMPLOYMENT_EMPLOYMENT_STATUS";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_INCOME"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_INCOME";
    TagKey["PERSONAL_EMPLOYMENT_PFCI_QUESTION"] = "PERSONAL_EMPLOYMENT_PFCI_QUESTION";
    TagKey["PERSONAL_INCOME_INCOME_FREQUENCY"] = "PERSONAL_INCOME_INCOME_FREQUENCY";
    TagKey["PERSONAL_INCOME_ADDITIONAL_INCOME_FREQUENCY"] = "PERSONAL_INCOME_ADDITIONAL_INCOME_FREQUENCY";
    TagKey["PERSONAL_INCOME_ADD_ADDITIONAL_INCOME"] = "PERSONAL_INCOME_ADD_ADDITIONAL_INCOME";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_COBORROWER"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_COBORROWER";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_COMMUNICATION"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_COMMUNICATION";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_IDENTITY"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_IDENTITY";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_ADDRESS"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_ADDRESS";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_EMPLOYMENT"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_EMPLOYMENT";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_INCOME"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_INCOME";
    TagKey["REFI_LEADS_PERSONAL_LEADS_SAVE"] = "REFI_LEADS_PERSONAL_LEADS_SAVE";
    TagKey["PERSONAL_CUSTOMER_PROFILE_TYPE"] = "PERSONAL_CUSTOMER_PROFILE_TYPE";
    TagKey["PERSONAL_IDENTITY_ACCESS_CODE_SSN_NO_MATCH"] = "PERSONAL_IDENTITY_ACCESS_CODE_SSN_NO_MATCH";
    TagKey["MOBILE_NUMBER_MODULE_SMS_OPT_SELECTION_FAILURE"] = "MOBILE_NUMBER_MODULE_SMS_OPT_SELECTION_FAILURE";
    TagKey["PERSONAL_IDENTITY_SSN_NO_MATCH_CONTINUE_WITHOUT_OFFER"] = "PERSONAL_IDENTITY_SSN_NO_MATCH_CONTINUE_WITHOUT_OFFER";
    TagKey["PERSONAL_IDENTITY_SSN_NO_MATCH_EDIT_DETAILS"] = "PERSONAL_IDENTITY_SSN_NO_MATCH_EDIT_DETAILS";
    TagKey["MOBILE_NUMBER_MODULE_TCPA_ALREADY_ASSOCIATED_ERROR_MESSAGE"] = "MOBILE_NUMBER_MODULE_TCPA_ALREADY_ASSOCIATED_ERROR_MESSAGE";
    TagKey["PERSONAL_CHECKOUT_PERSONAL_MFE_LOAD"] = "PERSONAL_CHECKOUT_PERSONAL_MFE_LOAD";
    TagKey["VIEW_PERSONAL_CHECKOUT"] = "VIEW_PERSONAL_CHECKOUT";
    TagKey["MOBILE_NUMBER_MODULE_TCPA_CONSENT_SAVED_TO_CUSTOMER_CONTACT"] = "MOBILE_NUMBER_MODULE_TCPA_CONSENT_SAVED_TO_CUSTOMER_CONTACT";
    TagKey["PERSONAL_CHECKOUT_PERSONAL_UPDATES_SAVE_SUCCESSFUL"] = "PERSONAL_CHECKOUT_PERSONAL_UPDATES_SAVE_SUCCESSFUL";
    TagKey["PERSONAL_CHECKOUT_PERSONAL_UPDATES_SAVE_FAILED"] = "PERSONAL_CHECKOUT_PERSONAL_UPDATES_SAVE_FAILED";
    TagKey["PERSONAL_CHECKOUT_SSN_CLICKED"] = "PERSONAL_CHECKOUT_SSN_CLICKED";
    TagKey["PERSONAL_CHECKOUT_UPDATE_PERSONAL_CLICKED"] = "PERSONAL_CHECKOUT_UPDATE_PERSONAL_CLICKED";
    TagKey["PERSONAL_CHECKOUT_CANCEL_PERSONAL_CLICKED"] = "PERSONAL_CHECKOUT_CANCEL_PERSONAL_CLICKED";
    TagKey["PQ_TEXT_INPUT_FIELD_CHANGED_FIELD"] = "PQ_TEXT_INPUT_FIELD_CHANGED_FIELD";
    TagKey["PERSONAL_CHECKOUT_PERSONAL_EDIT_COMPONENT_COLLAPSED"] = "PERSONAL_CHECKOUT_PERSONAL_EDIT_COMPONENT_COLLAPSED";
    TagKey["MOBILE_NUMBER_MODULE_TCPA_CONSENT_BOX_SHOWN"] = "MOBILE_NUMBER_MODULE_TCPA_CONSENT_BOX_SHOWN";
    TagKey["INCOME_CHECKOUT_POI_STIP_MUDFLAP_LOADS"] = "INCOME_CHECKOUT_POI_STIP_MUDFLAP_LOADS";
    TagKey["ADDRESS_CHECKOUT_POR_STIP_MUDFLAP_LOADS"] = "ADDRESS_CHECKOUT_POR_STIP_MUDFLAP_LOADS";
    TagKey["VIEW_PERSONAL_SNAG_PAGE"] = "VIEW_PERSONAL_SNAG_PAGE";
    TagKey["VIEW_PERSONAL_REVIEW"] = "VIEW_PERSONAL_REVIEW";
    TagKey["VIEW_PERSONAL_EDIT"] = "VIEW_PERSONAL_EDIT";
    TagKey["VIEW_ADDRESS_REVIEW"] = "VIEW_ADDRESS_REVIEW";
    TagKey["VIEW_ADDRESS_EDIT"] = "VIEW_ADDRESS_EDIT";
    TagKey["ADDRESS_PAGE_CO_BORROWER_ADDRESS"] = "ADDRESS_PAGE_CO_BORROWER_ADDRESS";
    TagKey["VIEW_EMPLOYMENT_REVIEW"] = "VIEW_EMPLOYMENT_REVIEW";
    TagKey["VIEW_EMPLOYMENT_EDIT"] = "VIEW_EMPLOYMENT_EDIT";
    TagKey["PERSONAL_PAGE_CO_BORROWER_ADDED"] = "PERSONAL_PAGE_CO_BORROWER_ADDED";
    TagKey["PQ_CONFIRMATION_EDIT_CLICKED"] = "PQ_CONFIRMATION_EDIT_CLICKED";
    TagKey["PQ_CONFIRMATION_CANCEL_CLICKED"] = "PQ_CONFIRMATION_CANCEL_CLICKED";
    TagKey["PQ_CONFIRMATION_SAVE_CLICKED"] = "PQ_CONFIRMATION_SAVE_CLICKED";
    TagKey["VIEW_COBORROWER_PERSONAL_REVIEW"] = "VIEW_COBORROWER_PERSONAL_REVIEW";
    TagKey["VIEW_COBORROWER_PERSONAL_EDIT"] = "VIEW_COBORROWER_PERSONAL_EDIT";
    TagKey["VIEW_COBORROWER_ADDRESS_REVIEW"] = "VIEW_COBORROWER_ADDRESS_REVIEW";
    TagKey["VIEW_COBORROWER_ADDRESS_EDIT"] = "VIEW_COBORROWER_ADDRESS_EDIT";
    TagKey["VIEW_COBORROWER_EMPLOYMENT_REVIEW"] = "VIEW_COBORROWER_EMPLOYMENT_REVIEW";
    TagKey["VIEW_COBORROWER_EMPLOYMENT_EDIT"] = "VIEW_COBORROWER_EMPLOYMENT_EDIT";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_CONSENT_MODAL_SHOWN"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_CONSENT_MODAL_SHOWN";
    TagKey["PQ_CONSENT_MODAL_PQ_CONSENT_AGREEMENT"] = "PQ_CONSENT_MODAL_PQ_CONSENT_AGREEMENT";
    TagKey["PQ_CONSENT_MODAL_PQ_CONSENT_CLOSE"] = "PQ_CONSENT_MODAL_PQ_CONSENT_CLOSE";
    TagKey["PQ_CONSENT_MODAL_PQ_CONSENT_PRIVACY_POLICY"] = "PQ_CONSENT_MODAL_PQ_CONSENT_PRIVACY_POLICY";
    TagKey["PQ_CONSENT_MODAL_PQ_CONSENT_PAPERKESS_AGREEMENT"] = "PQ_CONSENT_MODAL_PQ_CONSENT_PAPERKESS_AGREEMENT";
    TagKey["PAGE_VIEW_COAF_REFI_HOSTAPP_FAST_LANE"] = "PAGE_VIEW_COAF_REFI_HOSTAPP_FAST_LANE";
    TagKey["FAST_LANE_APP_START"] = "FAST_LANE_APP_START";
    TagKey["FAST_LANE_CO_APPLICANT_OR_REVIEW_INFO"] = "FAST_LANE_CO_APPLICANT_OR_REVIEW_INFO";
    TagKey["VIEW_FAST_LANE"] = "VIEW_FAST_LANE";
    TagKey["FAST_LANE_INVISIBLE_PREQUAL_CONSENT_SUBMIT"] = "FAST_LANE_INVISIBLE_PREQUAL_CONSENT_SUBMIT";
    TagKey["FAST_LANE_INVISIBLE_PREQUAL_CONSENT_MODAL_CLOSE"] = "FAST_LANE_INVISIBLE_PREQUAL_CONSENT_MODAL_CLOSE";
    TagKey["FAST_LANE_INVISIBLE_PREQUAL_CONSENT_PRIVACY_POLICY"] = "FAST_LANE_INVISIBLE_PREQUAL_CONSENT_PRIVACY_POLICY";
    TagKey["FAST_LANE_INVISIBLE_PREQUAL_CONSENT_PAPERLESS_AGREEMENT"] = "FAST_LANE_INVISIBLE_PREQUAL_CONSENT_PAPERLESS_AGREEMENT";
})(TagKey || (TagKey = {}));
// TAG_CATALOG is a required export of this file
const TAG_CATALOG = {
    /**
     * Add TagCatalog entries here. Best practice
     * is to use enumerated values for the tag keys.
     *
     * For properties with values of a specific type (like eventType),
     * export the corresponding type from the @cof/stratum package.
     */
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Personal Page',
        tagId: 2001,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_MODPREQUAL]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Modular Pre-qual Flow',
        tagId: 2002,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'modprequal',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.VIEW_PERSONAL_CONTACT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'TCPA checkbox is displayed to customer',
        tagId: 2003,
        featureName: 'personal contact'
    },
    [TagKey.PERSONAL_NAME_VIEW_ELIGIBILITY_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "View key eligibility requirements and product terms"',
        tagId: 2004,
        featureName: 'personal name',
        tagName: 'view eligibility modal',
        elementType: ElementType.LINK,
        action: EventAction.CLICK
    },
    [TagKey.PQ_TEXT_INPUT_FIELD_VIEW_FULL_ELIGIBILITY_REDIRECT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "full eligibility requirements and product terms" ',
        tagId: 2005,
        featureName: 'PQ Text Input Field',
        tagName: 'view full eligibility redirect',
        elementType: ElementType.LINK,
        action: EventAction.CLICK
    },
    [TagKey.PQ_TEXT_INPUT_FIELD_PREFILLED_FIELD]: {
        eventType: EventType.UI,
        tagDescription: 'System pre-filled input field in the application',
        tagId: 2006,
        featureName: 'PQ Text Input Field',
        tagName: 'prefilled field',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}'
    },
    [TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD]: {
        eventType: EventType.UI,
        tagDescription: 'User edited input field in the application',
        tagId: 2007,
        featureName: 'PQ Text Input Field',
        tagName: 'edited field',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}'
    },
    [TagKey.PERSONAL_NAME_CO_APPLICANT_ADDED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "add a co-applicant"',
        tagId: 2008,
        featureName: 'personal name',
        tagName: 'co applicant added',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_NAME]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod Name step is shown',
        tagId: 2009,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'name',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_COMMUNICATION]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod Communication step is shown',
        tagId: 2010,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'communication',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PREQUALIFY_NEXT_PAGE_CTA]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Next" button in prequal',
        tagId: 2011,
        featureName: 'prequalify',
        tagName: 'next page cta',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE]: {
        eventType: EventType.UI,
        tagDescription: 'User recieves invalid field criteria message',
        tagId: 2012,
        featureName: 'PQ Text Input Field',
        tagName: 'field validation error message',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}'
    },
    [TagKey.PERSONAL_COMMUNICATION_PHONE_NUMBER_TYPE]: {
        eventType: EventType.UI,
        tagDescription: 'User selects Phone Number Type drop down selection',
        tagId: 2013,
        featureName: 'personal communication',
        tagName: 'phone number type',
        elementType: ElementType.DROPDOWN,
        action: EventAction.SELECT,
        value: '${value}'
    },
    [TagKey.MOBILE_NUMBER_MODULE_CONFIRM_MOBILE_NUMBER_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'System displays OECP phone number modal ',
        tagId: 2014,
        featureName: 'Mobile Number Module',
        tagName: 'confirm mobile number modal',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD
    },
    [TagKey.MOBILE_NUMBER_MODULE_SMS_OPT_PHONE_CHANGE_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User selects radio button for automated SMS opt-in on submit of modal',
        tagId: 2015,
        featureName: 'Mobile Number Module',
        tagName: 'sms opt phone change modal',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PERSONAL_COMMUNICATION_SMS_OPT_SELECTION]: {
        eventType: EventType.UI,
        tagDescription: 'User selects radio button for automated SMS opt-in on submit of page',
        tagId: 2016,
        featureName: 'personal communication',
        tagName: 'sms opt selection',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.MOBILE_NUMBER_MODULE_PHONE_MODAL_SAVE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks the "save" button on Phone Number Modal',
        tagId: 2017,
        featureName: 'Mobile Number Module',
        tagName: 'phone modal save',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.MOBILE_NUMBER_MODULE_PHONE_MODAL_DISMISS]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks the exit icon or "cancel" button on Phone Number Modal',
        tagId: 2018,
        featureName: 'Mobile Number Module',
        tagName: 'phone modal dismiss',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.PERSONAL_COMMUNICATION_SMS_OPT_ON_PAGE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks checkbox for "I want to receive text messages about my application (optional)" on step submit',
        tagId: 2019,
        featureName: 'personal communication',
        tagName: 'sms opt on page',
        elementType: ElementType.CHECKBOX,
        action: EventAction.CHECK,
        value: '${value}'
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_IDENTITY]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod Identity step is shown',
        tagId: 2020,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'identity',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_ADDRESS]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Address page',
        tagId: 2021,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'address',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PERSONAL_EMPLOYMENT_ABOUT_EMPLOYMENT_STATUS_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "About Employment Status" link',
        tagId: 2022,
        featureName: 'personal employment',
        tagName: 'about employment status modal',
        elementType: ElementType.LINK,
        action: EventAction.CLICK
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_EMPLOYMENT]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Employment page',
        tagId: 2023,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'employment',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PERSONAL_EMPLOYMENT_EMPLOYMENT_STATUS]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks employment status from radio button options',
        tagId: 2024,
        featureName: 'personal employment',
        tagName: 'employment status',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_INCOME]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod Income step is shown',
        tagId: 2025,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'income',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PERSONAL_EMPLOYMENT_PFCI_QUESTION]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks PFCI question ratio button option',
        tagId: 2026,
        featureName: 'personal employment',
        tagName: 'pfci question',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PERSONAL_INCOME_INCOME_FREQUENCY]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks income payment frequency radio button',
        tagId: 2027,
        featureName: 'personal income',
        tagName: 'income frequency',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PERSONAL_INCOME_ADDITIONAL_INCOME_FREQUENCY]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks additional income payment schedule timeframe',
        tagId: 2028,
        featureName: 'personal income',
        tagName: 'additional income frequency',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PERSONAL_INCOME_ADD_ADDITIONAL_INCOME]: {
        eventType: EventType.UI,
        tagDescription: 'User selects "Add additional income source"',
        tagId: 2029,
        featureName: 'personal income',
        tagName: 'add additional income',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_COBORROWER]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod co-app step is shown',
        tagId: 2030,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'coborrower',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_COMMUNICATION]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod co-app-communication step is shown',
        tagId: 2031,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'co-app|communication',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_IDENTITY]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod co-app-identity step is shown',
        tagId: 2032,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'co-app|identity',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_ADDRESS]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod co-app-address step is shown',
        tagId: 2033,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'co-app|address',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_EMPLOYMENT]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod co-app-employment step is shown',
        tagId: 2034,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'co-app|employment',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_INCOME]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Mod co-app-income step is shown',
        tagId: 2035,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'co-app|income',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.REFI_LEADS_PERSONAL_LEADS_SAVE]: {
        eventType: EventType.UI,
        tagDescription: 'System saves personal data to the Refi Leads DB',
        tagId: 2036,
        featureName: 'refi leads',
        tagName: 'personal leads save',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT
    },
    [TagKey.PERSONAL_CUSTOMER_PROFILE_TYPE]: {
        eventType: EventType.UI,
        tagDescription: 'System identifies the profile of the customer on personal load',
        tagId: 2037,
        featureName: 'personal',
        tagName: 'customer profile type',
        elementType: ElementType.MESSAGE,
        action: EventAction.LOAD,
        value: '${value}'
    },
    [TagKey.PERSONAL_IDENTITY_ACCESS_CODE_SSN_NO_MATCH]: {
        eventType: EventType.UI,
        tagDescription: 'System displays access code SSN do not match on access code page message',
        tagId: 2038,
        featureName: 'personal identity',
        tagName: 'access code ssn no match',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD
    },
    [TagKey.MOBILE_NUMBER_MODULE_SMS_OPT_SELECTION_FAILURE]: {
        eventType: EventType.UI,
        tagDescription: 'Automated SMS opt-in failure on save button click',
        tagId: 2039,
        featureName: 'Mobile Number Module',
        tagName: 'sms opt selection failure',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.PERSONAL_IDENTITY_SSN_NO_MATCH_CONTINUE_WITHOUT_OFFER]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Continue without offer" when shown access code SSN do not match modal',
        tagId: 2040,
        featureName: 'personal identity',
        tagName: 'ssn no match continue without offer',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.PERSONAL_IDENTITY_SSN_NO_MATCH_EDIT_DETAILS]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Edit Details" when shown access code SSN do not match modal',
        tagId: 2041,
        featureName: 'personal identity',
        tagName: 'ssn no match edit details',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.MOBILE_NUMBER_MODULE_TCPA_ALREADY_ASSOCIATED_ERROR_MESSAGE]: {
        eventType: EventType.UI,
        tagDescription: 'TCPA "Phone number already associated" error message shown',
        tagId: 2042,
        featureName: 'Mobile Number Module',
        tagName: 'tcpa already associated error message',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT
    },
    [TagKey.PERSONAL_CHECKOUT_PERSONAL_MFE_LOAD]: {
        eventType: EventType.UI,
        tagDescription: 'Checkout page loads Personal MFE',
        tagId: 2043,
        featureName: 'Personal Checkout',
        tagName: 'personal mfe load',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}'
    },
    [TagKey.VIEW_PERSONAL_CHECKOUT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Personal Edit Component shown',
        tagId: 2044,
        featureName: 'Personal Checkout'
    },
    [TagKey.MOBILE_NUMBER_MODULE_TCPA_CONSENT_SAVED_TO_CUSTOMER_CONTACT]: {
        eventType: EventType.UI,
        tagDescription: 'System saves updated TCPA consent to customer contact',
        tagId: 2045,
        featureName: 'Mobile Number Module',
        tagName: 'tcpa consent saved to customer contact',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT
    },
    [TagKey.PERSONAL_CHECKOUT_PERSONAL_UPDATES_SAVE_SUCCESSFUL]: {
        eventType: EventType.UI,
        tagDescription: 'System saves updated personal information',
        tagId: 2046,
        featureName: 'Personal Checkout',
        tagName: 'personal updates save successful',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT
    },
    [TagKey.PERSONAL_CHECKOUT_PERSONAL_UPDATES_SAVE_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'System fails to save updated personal information',
        tagId: 2047,
        featureName: 'Personal Checkout',
        tagName: 'personal updates save failed',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT
    },
    [TagKey.PERSONAL_CHECKOUT_SSN_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User attempts to click locked SSN',
        tagId: 2048,
        featureName: 'Personal Checkout',
        tagName: 'ssn clicked',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR
    },
    [TagKey.PERSONAL_CHECKOUT_UPDATE_PERSONAL_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Update personal" CTA',
        tagId: 2049,
        featureName: 'Personal Checkout',
        tagName: 'update personal clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.PERSONAL_CHECKOUT_CANCEL_PERSONAL_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Cancel" CTA',
        tagId: 2050,
        featureName: 'Personal Checkout',
        tagName: 'cancel personal clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.PQ_TEXT_INPUT_FIELD_CHANGED_FIELD]: {
        eventType: EventType.UI,
        tagDescription: 'User changes personal info',
        tagId: 2051,
        featureName: 'PQ Text Input Field',
        tagName: 'changed field',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}'
    },
    [TagKey.PERSONAL_CHECKOUT_PERSONAL_EDIT_COMPONENT_COLLAPSED]: {
        eventType: EventType.UI,
        tagDescription: 'User collapses personal edit component',
        tagId: 2052,
        featureName: 'Personal Checkout',
        tagName: 'personal edit component collapsed',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.MOBILE_NUMBER_MODULE_TCPA_CONSENT_BOX_SHOWN]: {
        eventType: EventType.UI,
        tagDescription: 'User sees TCPA consent box',
        tagId: 2053,
        featureName: 'Mobile Number Module',
        tagName: 'tcpa consent box shown',
        elementType: ElementType.MESSAGE,
        action: EventAction.LOAD,
        value: '${value}'
    },
    [TagKey.INCOME_CHECKOUT_POI_STIP_MUDFLAP_LOADS]: {
        eventType: EventType.UI,
        tagDescription: 'POI Stip mudflap load successfully/fails',
        tagId: 2054,
        featureName: 'Income Checkout',
        tagName: 'poi stip mudflap loads',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}'
    },
    [TagKey.ADDRESS_CHECKOUT_POR_STIP_MUDFLAP_LOADS]: {
        eventType: EventType.UI,
        tagDescription: 'POR Stip mudflaps load successfully/fails',
        tagId: 2055,
        featureName: 'Address Checkout',
        tagName: 'por stip mudflap loads',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}'
    },
    [TagKey.VIEW_PERSONAL_SNAG_PAGE]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'User sees "We hit a snag" page',
        tagId: 2056,
        featureName: 'Personal Snag Page'
    },
    [TagKey.VIEW_PERSONAL_REVIEW]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Personal review component shown',
        tagId: 2057,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_PERSONAL_EDIT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Personal edit component shown',
        tagId: 2058,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_ADDRESS_REVIEW]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Address review component shown',
        tagId: 2059,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_ADDRESS_EDIT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Address edit component shown',
        tagId: 2060,
        featureName: 'PQ Confirmation'
    },
    [TagKey.ADDRESS_PAGE_CO_BORROWER_ADDRESS]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on toggle button to select that co borrower shares address or has a different address',
        tagId: 2061,
        featureName: 'Address Page',
        tagName: 'co borrower address',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.VIEW_EMPLOYMENT_REVIEW]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Employment review component shown',
        tagId: 2062,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_EMPLOYMENT_EDIT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Employment edit component shown',
        tagId: 2063,
        featureName: 'PQ Confirmation'
    },
    [TagKey.PERSONAL_PAGE_CO_BORROWER_ADDED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "apply with a co borrower" button on the personal page',
        tagId: 2064,
        featureName: 'Personal Page',
        tagName: 'co borrower added',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PQ_CONFIRMATION_EDIT_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks edit button on a review component',
        tagId: 2065,
        featureName: 'PQ Confirmation',
        tagName: 'edit clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PQ_CONFIRMATION_CANCEL_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks cancel button on an edit component',
        tagId: 2066,
        featureName: 'PQ Confirmation',
        tagName: 'cancel clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PQ_CONFIRMATION_SAVE_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks save button after updating an edit component',
        tagId: 2067,
        featureName: 'PQ Confirmation',
        tagName: 'save clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.VIEW_COBORROWER_PERSONAL_REVIEW]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Co-borrower personal review component shown',
        tagId: 2068,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_COBORROWER_PERSONAL_EDIT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Co-borrower personal edit component shown',
        tagId: 2069,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_COBORROWER_ADDRESS_REVIEW]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Co-borrower address review component shown',
        tagId: 2070,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_COBORROWER_ADDRESS_EDIT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Co-borrower address edit component shown',
        tagId: 2071,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_COBORROWER_EMPLOYMENT_REVIEW]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Co-borrower employment review component shown',
        tagId: 2072,
        featureName: 'PQ Confirmation'
    },
    [TagKey.VIEW_COBORROWER_EMPLOYMENT_EDIT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Co-borrower employment edit component shown',
        tagId: 2073,
        featureName: 'PQ Confirmation'
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_CONSENT_MODAL_SHOWN]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'PQ Consent Modal shown',
        tagId: 2075,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'personal',
            level5: 'consent modal',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.PQ_CONSENT_MODAL_PQ_CONSENT_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks the "i agree" button on the PQ Consent Modal',
        tagId: 2076,
        featureName: 'PQ Consent Modal',
        tagName: 'pq consent agreement',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}'
    },
    [TagKey.PQ_CONSENT_MODAL_PQ_CONSENT_CLOSE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on the "X" button on the PQ Consent Modal',
        tagId: 2077,
        featureName: 'PQ Consent Modal',
        tagName: 'pq consent close',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.PQ_CONSENT_MODAL_PQ_CONSENT_PRIVACY_POLICY]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Privacy Policies"',
        tagId: 2078,
        featureName: 'PQ Consent Modal',
        tagName: 'pq consent privacy policy',
        elementType: ElementType.LINK,
        action: EventAction.CLICK
    },
    [TagKey.PQ_CONSENT_MODAL_PQ_CONSENT_PAPERKESS_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Paperless Agreement"',
        tagId: 2079,
        featureName: 'PQ Consent Modal',
        tagName: 'pq consent paperless agreement',
        elementType: ElementType.LINK,
        action: EventAction.CLICK
    },
    [TagKey.PAGE_VIEW_COAF_REFI_HOSTAPP_FAST_LANE]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Fast Lane entry page viewed',
        tagId: 2080,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'hostapp',
            level4: 'fast lane',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance'
        }
    },
    [TagKey.FAST_LANE_APP_START]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Let\'s get started"',
        tagId: 2081,
        featureName: 'Fast Lane',
        tagName: 'app start',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.FAST_LANE_CO_APPLICANT_OR_REVIEW_INFO]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Apply with a co-applicant"',
        tagId: 2082,
        featureName: 'Fast Lane',
        tagName: 'co-applicant or review info',
        elementType: ElementType.LINK,
        action: EventAction.CLICK
    },
    [TagKey.VIEW_FAST_LANE]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Customer is shown Fast Lane consent modal',
        tagId: 2083,
        featureName: 'Fast Lane'
    },
    [TagKey.FAST_LANE_INVISIBLE_PREQUAL_CONSENT_SUBMIT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "I agree" button',
        tagId: 2084,
        featureName: 'Fast Lane',
        tagName: 'invisible prequal consent submit',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK
    },
    [TagKey.FAST_LANE_INVISIBLE_PREQUAL_CONSENT_MODAL_CLOSE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks to close the consent modal',
        tagId: 2085,
        featureName: 'Fast Lane',
        tagName: 'invisible prequal consent modal close',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD
    },
    [TagKey.FAST_LANE_INVISIBLE_PREQUAL_CONSENT_PRIVACY_POLICY]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Privacy Policies"',
        tagId: 2086,
        featureName: 'Fast Lane',
        tagName: 'invisible prequal consent privacy policy',
        elementType: ElementType.LINK,
        action: EventAction.CLICK
    },
    [TagKey.FAST_LANE_INVISIBLE_PREQUAL_CONSENT_PAPERLESS_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Paperless Agreement"',
        tagId: 2087,
        featureName: 'Fast Lane',
        tagName: 'invisible prequal consent paperless agreement',
        elementType: ElementType.LINK,
        action: EventAction.CLICK
    }
};

export { PRODUCT_NAME, PRODUCT_VERSION, TAG_CATALOG, TagKey };
